import React, { useState, useEffect, useRef } from 'react';
import closeIcon from '../../Assets/Icons/close.png';
import searchIcon from '../../Assets/Icons/search.png';
import Dropdown from '../Dropdown';
import Input from '../Input';
import TextInput from '../TextInput';
import { ORG_SHARE_DOC_CLIENT } from '../../ApiServices/BaseURL';
import { useTheme } from '../../GlobalContext/GlobalContext';
import { postData } from '../../ApiServices/ApiService';
import Loader from '../Loader';

const ShareDocumentModal = ({ isOpen, onClose, documentData }) => {

    const [selectedClient, setSelectedClient] = useState(documentData?.client_name || '');
    const [clientId, setClientId] = useState(documentData?.client_id || '');
    const [documentId, setDocumentId] = useState(documentData?.doc_id || '');
    const [deliveryType, setDeliveryType] = useState(null);
    const [deliveryTypeError, setDeliveryTypeError] = useState(null);
    const [templateType, setTemplateType] = useState(null);
    const [templateList, setTemplateList] = useState([]);
    const [documentName, setDocumentName] = useState(documentData?.doc_name || '');
    const [documentNameError, setDocumentNameError] = useState('');
    const [success, setSuccess] = useState('');
    const [comment, setComment] = useState('');
    const channelOptions = [
        { label: "WhatsApp", value: 'whatsapp' },
        { label: "Email", value: 'email' },
    ];

    const { setIsLoginPopup } = useTheme();

    const [clientList, setClientList] = useState([]);
    const [error, setError] = useState('');
    const [searchUser, setSearchUser] = useState('');
    const [selectedClientError, setSelectedClientError] = useState('');
    const [selectedClients, setSelectedClients] = useState([]);
    const [loading, setLoading] = useState(false)
    const [clientNameError, setClientNameError] = useState('');

    useEffect(() => {

        if (documentData && isOpen) {
            console.log('documentData"-', documentData)
            setSelectedClient(documentData?.client_name)
            setDocumentName(documentData?.doc_name)
            setClientId(documentData?.client_id)
            setDocumentId(documentData?.doc_id)
        }
    }, [isOpen, documentData]);


    const handleShare = async () => {
        try {
            setDocumentNameError('')
            setDeliveryTypeError('')
            setError('');
              if(!deliveryType){
                setDeliveryTypeError('Please select channel');return

            }
            if(!documentName){
                setDocumentNameError('Please enter document name');
                return
            }
          
            setLoading(true);

            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            const payLoad = {
                emp_id_auth: storedUserInfo?.emp_id,
                client_id: clientId || 0,
                channel: deliveryType || '',
                doc_name: documentName || '',
                comment: comment || '',
                doc_id:documentId || 0
            };
            //console.log('team Data', payLoad);
            // Make the API call
            const response = await postData(ORG_SHARE_DOC_CLIENT, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setSuccess(responseData?.info || '')
                        setTimeout(() => {
                            setSuccess('')
                            clearData()
                        }, 3000);

                    } else {
                        setError(responseData?.info || 'Failed to share document. Please try again.');
                    }
                } else {
                    setError(responseData?.info || 'Failed to share document.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
            }
            else {
                setError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            setError(`Something went wrong while processing your request. Please check your network connection and try again.`);

        } finally {
            setLoading(false);
        }

    };
    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    const dropdownRefs = useRef({}); // Ref for dropdown

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // const handleChannelTemplate = async (channelType) => {
    //     try {
    //         setError('');
    //         setLoading(true);
    //         setTemplateList([]);

    //         const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    //         const payLoad = {
    //             emp_id_auth: storedUserInfo?.emp_id,
    //             channel_type: channelType || '',
    //         }

    //         //console.log('team Data', payLoad);
    //         // Make the API call
    //         const response = await postData(ORG_GET_TEMPLATE_LIST, payLoad);
    //         const responseData = await response.json();
    //         //console.log('response Data', responseData);

    //         // Check for success (200) and internal status code
    //         if (response?.status === 200) {
    //             if (responseData?.status_code === 200) {
    //                 if (responseData?.message.toLowerCase() === 'success') {
    //                     if (responseData?.dataJ?.length > 0) {
    //                         const filterData = responseData?.dataJ.map(service => ({
    //                             label: service?.template_name,
    //                             value: service?.template_id
    //                         }));
    //                         setTemplateList(filterData)
    //                     } else {
    //                         setError(responseData?.info || 'Data Not Found');
    //                     }

    //                 } else {
    //                     setError(responseData?.info || 'Failed to fetch template. Please try again.');
    //                 }
    //             } else {
    //                 setError(responseData?.info || 'Failed to fetch template.');
    //             }
    //         }
    //         // Token-related errors: 400, 401, 403
    //         else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
    //             setError('Unauthorized access. Your session may have expired. Please log in again.');
    //             setIsLoginPopup(true)
    //         }
    //         else {
    //             setError('Unexpected error occurred. Please try again later.');
    //         }
    //     } catch (error) {
    //         setError(`Something went wrong while processing your request. Please check your network connection and try again.`);

    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleChannelChange = (type) => {
        setDeliveryType(type?.value)
        // handleChannelTemplate(type?.value)
    }

    const handleSearchInputText = (value) => {
        setSearchUser(value);
        setClientNameError('');
        setClientList([]);
        if (!value) {
            setSearchUser('');
        }
    };

    const handleSelectClient = (client) => {
        setSelectedClient(client); // Set selected client data
        setSearchUser(client?.client_name); // Update TextInput with the selected client's name
        setClientList([]); // Clear the dropdown
        setSelectedClientError('');
    }
    const clearData = () => {
        // setSelectedClient('');
        setDeliveryType(null);
        setDeliveryTypeError('')
        setDocumentNameError('')
        setComment('');
        setSuccess('')
        onClose();
    }


    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div style={styles.header}>
                    <h2 className="modal-title">Share Document</h2>
                    <button className="close-button" onClick={clearData}>
                        <img src={closeIcon} alt="Close" style={styles.iconImage} />
                    </button>
                </div>
                <hr className='footer-divider' />
                <div className="form-grid">

                    {/* Client Name with Search Icon */}
                    <div className="filter-field">
                        <label>Client Name</label>
                        <TextInput
                            type="text"
                            placeholder="Client"
                            value={selectedClient}
                            onChange={(e) => handleSearchInputText(e.target.value)}

                            style={{ padding: '20px 10px' }}
                            // errorMessage={clientNameError || error}
                            width={280}
                            isEdit={false}
                        />

                    </div>
                    {/* Delivery Type Dropdown */}
                    <Dropdown
                        ref={(el) => (dropdownRefs.current["channel"] = el)}
                        isOpen={openDropdown === "channel"}
                        toggleDropdown={() => toggleDropdown("channel")}
                        label="Channel"
                        options={channelOptions}
                        value={deliveryType}
                        onChange={(value) => { handleChannelChange(value); setComment('');setDeliveryTypeError('') }}
                        errorMessage={deliveryTypeError}
                    />

                    {/* Delivery Type Dropdown */}
                    {/* <Dropdown
                        ref={(el) => (dropdownRefs.current["template"] = el)}
                        isOpen={openDropdown === "template"}
                        toggleDropdown={() => toggleDropdown("template")}
                        label="Template"
                        options={templateList || []}
                        value={templateType}
                        onChange={setTemplateType}
                        loading={loading}
                        errorMessage={error}
                    /> */}

                    {/* Document Name */}
                    {console.log("documentName",documentName)}
                    <Input
                        label="Document Name"
                        value={documentName}
                        onChange={(e) => { setDocumentName(e.target.value);setDocumentNameError('') }}
                        errorMessage={documentNameError}
                    // isEdit={false}
                    />
                </div>
                {deliveryType === 'whatsapp' ? '' :
                    <div style={{ width: "95%", display: "flex", marginTop: '15px' }}>
                        <div style={{ width: "100%" }}>
                            <label style={{ ...styles.labaleStyle, display: "block" }}>
                                Comment
                            </label>
                            <textarea
                                placeholder="Add a comment"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                style={{ ...styles.textarea, width: "100%" }}
                                rows={6}
                            />
                        </div>
                    </div>}
                <hr className='footer-divider' />
                <div className="button-container">
                    <button className="add-client-button" onClick={handleShare} style={{opacity:loading || success ? 0.5:1}} disabled={loading || success}>
                        {loading && <span style={{paddingRight:10}}> <Loader loading={true} size="small" color="white" /> </span>} Share
                    </button>
                    <button className="cancel-button" onClick={clearData}>
                        {/* {console.log("clear Data",clearData)} */}
                        Cancel
                    </button>
                    {success && <div className="list-success-msg"> {success}</div>}
                    {error && <div className="list-error-msg"> {error}</div>}
                </div>
            </div>
        </div>
    );
};

const styles = {

    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        fontSize: '18px',
        fontWeight: '600',
    },
    iconImage: {
        width: '14px',
        height: '14px',
    },
    divider: {
        margin: '15px 0',
    },

    inputWithIcon: {
        position: 'relative',
    },
    searchIcon: {
        position: 'absolute',
        right: '10px',
        top: '35px',
        width: '16px',
        height: '16px',
        pointerEvents: 'none',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: '15px',
    },
    primaryButton: {
        padding: '10px 25px',
        backgroundColor: '#2C3E50',
        color: '#fff',
        borderRadius: '6px',
        border: 'none',
        cursor: 'pointer',
    },
    cancelButton: {
        padding: '10px 25px',
        backgroundColor: '#f5f5f5',
        color: '#333',
        borderRadius: '6px',
        border: '1px solid #ccc',
        cursor: 'pointer',
    },
    textarea: {
        border: "1px solid #d1e3ed",
        borderRadius: "5px",
        fontSize: "14px",
        padding: "10px",
        width: "100%",
        resize: "none", // Prevents resizing for consistent appearance
    },
    labaleStyle: {
        fontSize: '12px',
        marginBottom: '5px',
        fontWeight: '400',
        fontFamily: 'Roboto',
        color: 'rgb(52, 60, 68)'
    },
    dropdownList: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 1000,
        padding: 0, // Remove default padding
        margin: 0, // Remove default margin
        listStyleType: 'none', // Remove the dots
    },
    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee', // Default for all items
        backgroundColor: '#fff',
        hover: {
            backgroundColor: '#f0f0f0',
        },
    },
};

export default ShareDocumentModal;
